import type { BrokenCondition } from './checkQuestionChangeConditions';
import type { Question } from '@aphp-ema/common/questionnaire';

/**
 * Check if reordering questions would break any conditions
 * Returns list of questions that would have broken conditions
 */
export const checkReorderConditions = (
  questions: Question[],
  fromIndex: number,
  toIndex: number,
): BrokenCondition[] => {
  if (fromIndex === toIndex) {
    return [];
  }

  // Create preview order
  const previewOrder = [...questions];
  const [draggedItem] = previewOrder.splice(fromIndex, 1);
  previewOrder.splice(toIndex, 0, draggedItem);

  // Check each question's conditions in the new order
  const brokenConditions: BrokenCondition[] = [];

  previewOrder.forEach((question, newIndex) => {
    const conditions = question.displayConditions?.conditions || [];

    conditions.forEach((condition) => {
      if (condition.target?.source === 'question') {
        const questionTarget = condition.target;
        const targetIndex = previewOrder.findIndex(
          (q) => q.id === questionTarget.questionId,
        );
        // Condition is invalid if target comes after or at the same position
        if (targetIndex >= newIndex) {
          brokenConditions.push({
            questionId: question.id,
            reason: 'reordering',
            condition,
          });
        }
      }
    });
  });

  return brokenConditions;
};
